module.exports = __webpack_public_path__ + "static/media/check-mark.b7e25def.svg";